import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addToCart } from "../redux/shopSlice";
import { ToastContainer, toast } from "react-toastify";

function ProductsCard({ product }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const _id = product.id;

  const handleDetails = () => {
    navigate(`/product/${_id}`, {
      state: {
        item: product,
      },
    });
  };

  return (
	<div>
    <div className=" sm:block lg:mx-auto sm:w-1/2">
      <div className="max-w-3xl">
        <div className="bg-white shadow-md rounded-lg max-w-lg dark:bg-gray-800 dark:border-gray-700 overflow-hidden group">
          <p>
            <img
              className="rounded-t-lg object-cover bg-slate-300 transform group-hover:scale-110 duration-500 h-52 max-h-56 w-full mb-3"
              src={product.image}
              alt="product-img"
            />
          </p>
          <div className="px-5 pb-5 ">
            <div className="group-hover:translate-x-10 transition-transform duration-500">
              <span className="text-1xl font-bold text-yellow-700 dark:text-yellow-400 ">
                {product.price}&pi;
              </span>
            </div>
            <div onClick={handleDetails}>
              <p>
                <h3 className="text-gray-900 font-semibold text-sm tracking-tight dark:text-white">
                  {product.title.substring(0, 37)}
                  {product.title.length > 37 ? "..." : ""}{" "}
                </h3>
              </p>
            </div>
            {/* <div className="flex items-center mt-2.5 mb-5">
					<svg className="w-5 h-5 text-yellow-300" fill="currentColor" viewBox="0 0 20 20"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z">
						</path>
					</svg>
					<svg className="w-5 h-5 text-yellow-300" fill="currentColor" viewBox="0 0 20 20"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z">
						</path>
					</svg>
					<svg className="w-5 h-5 text-yellow-300" fill="currentColor" viewBox="0 0 20 20"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z">
						</path>
					</svg>
					<svg className="w-5 h-5 text-yellow-300" fill="currentColor" viewBox="0 0 20 20"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z">
						</path>
					</svg>
					<svg className="w-5 h-5 text-yellow-300" fill="currentColor" viewBox="0 0 20 20"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z">
						</path>
					</svg>
					<span className="bg-blue-100 text-blue-800 text-xs font-semibold mr-2 px-2.5  rounded dark:bg-blue-200 dark:text-blue-800 ml-3">5.0</span>
				</div> */}
            <div className="flex items-center justify-center mt-3">
              {/* <span className="text-1xl font-bold text-gray-900 dark:text-white">$599</span>
					
					<a href="#"
						className="text-white bg-slate-700 active:bg-slate-800 active:ring-4 active:ring-slate-500 font-medium rounded-lg text-xs px-2 py-2 text-center dark:bg-yellow-600 dark:active:bg-yellow-700 dark:active:ring-yellow-600 dark:text-slate-900 font-semibold">Buy Now
						</a> */}

              <div
                onClick={() =>
                  dispatch(
                    addToCart({
                      _id: product.id,
                      title: product.title,
                      image: product.image,
                      price: product.price,
                      quantity: 1,
                    })
                  ) & toast.success(`${product.title} added to Cart`)
                }
                className="text-white bg-slate-700 active:bg-slate-800 active:ring-4 active:ring-slate-500 font-medium rounded-lg text-xs px-8 py-2 text-center dark:bg-yellow-600 dark:active:bg-yellow-700 dark:active:ring-yellow-600 dark:text-slate-900 font-semibold hover:scale-105 duration-100 cursor-pointer"
              >
                Add to cart
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
	<ToastContainer
          position="top-left"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          toastClassName="custom-toast-background"
        />
	</div>
  );
}

export default ProductsCard;
